import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';


@Injectable({
  providedIn: 'root'
})
export class FormOfflineService {

  private apiBookingUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) { }

  createRequestOffline(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBookingUrl}offline-requests`, payload);
  }

  /**
   * Obtiene los itineraries de un agente para el selector de files existentes.
   * Endpoint: GET itineraries?page={page}&agent_id={agentId}
   */
  getItinerariesForAgent(agentId: number, page = 1): Observable<any> {
    return this.http.get<any>(`${this.apiBookingUrl}itineraries?page=${page}&agent_id=${agentId}`);
  }
}
